import { BASE_IMPORT_DATA } from "@/Modals/Profiles/BaseImport/baseImportData";
import React from "react";
import PlayerCareerModal from "@/Modals/Profiles/PlayerCareers/Modal";
import { columns } from "./Columns";
import { playerCareersApi } from "@/apis/apis";
import BaseTable from "./BaseTable";

export default function PlayerCareersPage() {
  return (
    <BaseTable
      label="Career Team History"
      apiURL={playerCareersApi}
      columns={columns()}
      ModalComponent={PlayerCareerModal}
      importData={BASE_IMPORT_DATA.PLAYER_CAREERS}
      enableSortData={false}
      enableStatus={false}
    />
  );
}
